import {
  IPageAndSearchRequest,
  IReactQueryApiState,
  IViewTransaction,
  PagedMeta,
} from "../../interfaces-and-types";
import { useMerchantApiQueryWithParams } from "../../hooks";

import { View } from "./View";

/**
 * Displays transactions as a list eg previous transactions by customer etc
 * @param filterList: function to filter list by before display eg filter out currently viewed tx etc
 */
export interface IPaymentsListProps {
  search: string | null;
  enabled: boolean;
  filterList?: (tx: IViewTransaction) => boolean;
  loadingMessage: string;
}

export interface IPaymentsListViewProps
  extends IReactQueryApiState<IViewTransaction[]> {
  filterList?: (tx: IViewTransaction) => boolean;
  loadingMessage: string;
}

export const PaymentsList = (props: IPaymentsListProps) => {
  const customerTransactionsResponse = useMerchantApiQueryWithParams<
    IPageAndSearchRequest,
    IViewTransaction[],
    PagedMeta
  >(
    [
      "getTransactions",
      {
        page: 1,
        page_size: 11,
        search: props.search,
      },
    ],
    {
      enabled: props.enabled,
    }
  );

  return (
    <View
      filterList={props.filterList}
      {...customerTransactionsResponse}
      loadingMessage={props.loadingMessage}
    />
  );
};
